import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Wordmark } from "@/components/Logo";

const LINKS = [
  { label: "Services", to: "/#services", testid: "nav-link-services" },
  { label: "Our Focus", to: "/#focus", testid: "nav-link-focus" },
  { label: "About", to: "/#about", testid: "nav-link-about" },
  { label: "Contact", to: "/contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-transparent border-b border-black/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" aria-label="Symmori home" onClick={() => setOpen(false)}>
          <Wordmark />
        </Link>

        <nav className="hidden lg:flex items-center gap-10" aria-label="Primary">
          {LINKS.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={l.testid}
              className="text-sm tracking-wide text-charcoal/80 hover:text-ink transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-mutedblue after:transition-all after:duration-300 hover:after:w-full"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta"
            className="group inline-flex items-center gap-2 bg-ink text-white text-sm px-6 py-3 transition-colors duration-300 hover:bg-mutedblue"
          >
            Discuss a Campaign
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </nav>

        <button
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="mobile-menu-button"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav
          className="lg:hidden border-t border-black/5 bg-offwhite/95 backdrop-blur-xl"
          aria-label="Mobile"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                data-testid={`mobile-${l.testid}`}
                onClick={() => setOpen(false)}
                className="font-serif text-2xl tracking-tight text-ink"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-nav-cta"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center gap-2 bg-ink text-white text-sm px-6 py-4 mt-2"
            >
              Discuss a Campaign
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
};
